import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./AnnouncementBar.module.css";

const STORAGE_KEY = "vr-announce-dismissed-v1";

export function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") setDismissed(true);
    } catch {
      /* ignore */
    }
  }, []);

  if (dismissed) return null;

  function dismiss() {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
  }

  return (
    <div className={styles.bar}>
      <Link to="/book-a-stay" className={styles.message}>
        <span className={styles.dot} aria-hidden="true" />
        <span>
          Now booking 2026 weddings, events &amp; getaways
        </span>
        <span className={styles.cta}>Check availability&nbsp;→</span>
      </Link>
      <button
        type="button"
        className={styles.close}
        onClick={dismiss}
        aria-label="Dismiss announcement"
      >
        ×
      </button>
    </div>
  );
}
